<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ titleText }}</h1>
      <p class="subtitle">{{ tip }}</p>
      <form @submit.prevent="onSubmit">
        <b-field
          label="Наслов"
          :type="$v.naslov.$error ? 'is-danger' : ''"
          :message="$v.naslov.$error ? 'Наслов је обавезан' : ''"
        >
          <b-input v-model="naslov"></b-input>
        </b-field>
        <b-field label="Датум">
          <b-datepicker v-model="datum"> </b-datepicker>
        </b-field>
        <b-field label="Текст">
          <b-input v-model="tekst" maxlength="4000" type="textarea"></b-input>
        </b-field>
        <!-- slika -->
        <b-field class="file is-primary">
          <b-upload @input="dodajResursSliku" class="file-label">
            <!-- <span class="file-cta">
              <span class="file-label">Изабери слику</span>
            </span> -->
            <a>Слике</a>
          </b-upload>
        </b-field>
        <div class="tags">
          <span class="tag" v-for="s in slike" :key="s.id">
            {{ s.tekst }}
            <button
              class="delete is-small"
              type="button"
              @click="deleteSelectedSlika(s.id)"
            ></button>
          </span>
        </div>
        <!-- dokument -->
        <b-field class="file is-primary">
          <b-upload @input="dodajResursDokument" class="file-label">
            <!-- <span class="file-cta">
              <span class="file-label">Изабери документ</span>
            </span> -->
            <a>Документи</a>
          </b-upload>
        </b-field>
        <div class="tags">
          <span class="tag" v-for="d in dokumenti" :key="d.id">
            {{ d.tekst }}
            <button
              class="delete is-small"
              type="button"
              @click="deleteSelectedDokument(d.id)"
            ></button>
          </span>
        </div>

        <!-- links -->
        <b-field class="is-primary">
          <a @click="isModalResursLinkActive = true">Линкови</a>
        </b-field>
        <div class="tags">
          <span class="tag" v-for="l in linkovi" :key="l.id">
            {{ l.tekst }}
            <button
              class="delete is-small"
              type="button"
              @click="deleteSelectedLink(l.id)"
            ></button>
          </span>
        </div>

        <!-- buttons -->
        <div class="level">
          <b-button native-type="submit">Сачувај</b-button>
          <b-button native-type="button" @click="onDeleteClick" v-show="id"
            >Обриши</b-button
          >
          <b-button class="is-pulled-right" tag="router-link" :to="returnTo"
            >Назад</b-button
          >
        </div>
      </form>
    </div>

    <b-modal v-model="isModalActive" :width="640">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Брисање података</p>
          <!-- <button type="button" class="delete" @click="isModalActive = false" /> -->
        </header>
        <section class="modal-card-body">
          Подаци ће бити обрисани. Да ли сте сигурни?
        </section>
        <footer class="modal-card-foot" style="justify-content: space-between;">
          <button
            class="button is-primary is-pulled-right"
            @click="obrisiResurs"
          >
            Да
          </button>
          <button class="button" type="button" @click="isModalActive = false">
            Не
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal v-model="isModalResursLinkActive" :width="640">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Нови линк</p>
          <!-- <button type="button" class="delete" @click="isModalActive = false" /> -->
        </header>
        <section class="modal-card-body">
          <b-field label="Текст">
            <b-select
              v-model="element_tekst"
              placeholder="Изабери текст"
              expanded
            >
              <option>Позив за подношење понуда</option>
              <option>Конкурскна документација</option>
              <option>Обавештење о продужетку рока за подношење понуда</option>
              <option
                >Питања и одговори везани за конкурсну документацију</option
              >
              <option>Обавештење о поднетом захтеву за заштиту права</option>
              <option>Измена и допуна конкурсне документације</option>
              <option>Обавештење о закљученом уговору</option>
              <option>Одлука о додели уговора</option>
              <option>Одлука о обустави поступка</option>
              <option>Обавештење о обустави поступка</option>
            </b-select>
          </b-field>
          <b-field label="Линк">
            <b-input v-model="element_url"></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot" style="justify-content: space-between;">
          <button
            class="button is-primary is-pulled-right"
            @click="dodajResursElement"
          >
            Додај
          </button>
          <button
            class="button"
            type="button"
            @click="isModalResursLinkActive = false"
          >
            Откажи
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  props: ['id', 'tip'],
  data() {
    return {
      //id: this.resurs.id,
      //tip: this.resurs.tip,
      naslov: null,
      datum: null,
      tekst: null,
      //slike: null,
      // naziv_slike: null,
      //dokumenti: null,
      // naziv_dokumenta: null,
      isModalActive: false,
      isModalResursLinkActive: false,
      element_tekst: '',
      element_url: '',
      elementi: []
    }
  },
  created() {
    // if (!this.id) {
    //   this.resetujFormu()
    // } else {
    //   // poziva metof koji je mapirana akcija iz modula resursi.js
    //   // ova akcija poziva svoj getter dajResursById
    //   // ako getter nadje resurrs commit-uje ga u state
    //   // a ako ne prvo trazi iz baze pa commit-uje
    //   this.dajResurs(this.id)

    //   // moze i ovako
    //   // this.$store.dispatch('resursi/dajResurs', this.id).catch(error => {
    //   //   console.log('Error:' + error.response)
    //   // })
    // }

    if (!this.id) {
      this.resetujFormu()
    } else {
      // ovo je ranije bilo u watch ali nesto nije radilo nakon izmena
      // vezano za cekanje podataka i progress
      // nakon izmena resurs se ucitava u state.resursi.resurs (router/index.js beforeEnter)
      // posto se created poziva posle toga ovo ovde radi

      this.id = this.resurs.id
      this.tip = this.resurs.tip
      this.naslov = this.resurs.naslov
      this.datum = moment(this.resurs.datum).toDate()
      this.tekst = this.resurs.tekst
      this.elementi = this.resurs.elementi
      // this.naziv_slike = this.resurs.naziv_slike
      // this.naziv_dokumenta = this.resurs.naziv_dokumenta
      this.slike_upload
      this.dokumenti_upload
    }
  },
  methods: {
    resetujFormu() {
      this.naslov = null
      this.datum = null
      this.tekst = null
      this.elementi = []
      // this.slika = null
      // this.naziv_slike = null
      //this.slike = null
      // this.dokument = null
      // this.naziv_dokumenta = null
      //this.dokumenti = null
    },
    // deleteSelectedImage() {
    //   this.slika = null
    //   this.naziv_slike = null
    // },
    // deleteSelectedDokument() {
    //   this.dokument = null
    //   this.naziv_dokumenta = null
    // },
    deleteSelectedSlika(id) {
      var e = null
      for (let index = 0; index < this.elementi.length; index++) {
        if (this.elementi[index].id === id) {
          e = this.elementi[index]
          e.obrisan = true
          break
        }
      } // nece samo ovako da se update-uje pa mora ovo nize

      this.elementi = this.elementi.filter(e => {
        return e.id != id
      })
      this.elementi.push(e)
    },
    deleteSelectedDokument(id) {
      var e = null
      for (let index = 0; index < this.elementi.length; index++) {
        if (this.elementi[index].id === id) {
          e = this.elementi[index]
          e.obrisan = true
          break
        }
      } // nece samo ovako da se update-uje pa mora ovo nize

      this.elementi = this.elementi.filter(e => {
        return e.id != id
      })
      this.elementi.push(e)
    },
    deleteSelectedLink(id) {
      var e = null
      for (let index = 0; index < this.elementi.length; index++) {
        if (this.elementi[index].id === id) {
          e = this.elementi[index]
          e.obrisan = true
          break
        }
      } // nece samo ovako da se update-uje pa mora ovo nize

      this.elementi = this.elementi.filter(e => {
        return e.id != id
      })
      this.elementi.push(e)
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d)
    },
    onSubmit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        console.log('ERROR')
        return
      }

      //debugger

      const resurs = {
        id: this.id,
        tip: this.tip,
        naslov: this.naslov,
        //datum: this.datum.toLocaleDateString('sr'),
        //datum: this.datum.toISOString().substring(0, 10),
        datum: this.isValidDate(this.datum)
          ? this.datum.getFullYear() +
            '-' +
            (this.datum.getMonth() + 1) +
            '-' +
            this.datum.getDate()
          : '',
        tekst: this.tekst,
        elementi: this.elementi
        //slika: this.slika,
        //naziv_slike: this.slika ? this.slika.name : this.naziv_slike,
        //naziv_slike: this.naziv_slike, // novi naziv ako postoji ???
        //naziv_slike_stari: this.resurs ? this.resurs.naziv_slike : null, // stari naziv ako je postojao
        //dokument: this.dokument,
        // naziv_dokumenta: this.dokument
        //   ? this.dokument.name
        //   : this.naziv_dokumenta,
        //naziv_dokumenta: this.naziv_dokumenta, // novi naziv ako postoji ???
        //naziv_dokumenta_stari: this.resurs ? this.resurs.naziv_dokumenta : null // stari naziv ako je postojao
      }
      console.log(resurs)

      if (this.id) {
        this.$Progress.start()
        this.$store
          .dispatch('resursi/izmeniResurs', resurs)
          .then(() => {
            this.slika = null
            this.dokument = null
            this.$Progress.finish()
            this.$buefy.snackbar.open('Подаци су сачувани успешно')
          })
          .catch(error => {
            this.$Progress.finish()
            this.$buefy.snackbar.open({
              message: 'Дошло је до грешке!',
              type: 'is-danger'
            })
            console.log(error.response)
          })
      } else {
        this.$Progress.start()
        this.$store
          .dispatch('resursi/dodajResurs', resurs)
          .then(() => {
            this.slika = null
            this.dokument = null
            this.$Progress.finish()
            this.$buefy.snackbar.open('Подаци су сачувани успешно')
          })
          .catch(error => {
            this.$Progress.finish()
            this.$buefy.snackbar.open({
              message: 'Дошло је до грешке!',
              type: 'is-danger'
            })
            console.log(error.response)
          })
      }
    },
    onDeleteClick() {
      // show modal
      this.isModalActive = true
    },
    obrisiResurs() {
      this.isModalActive = false
      console.log('brisanje ...')

      if (this.id) {
        this.$Progress.start()
        this.$store
          .dispatch('resursi/obrisiResurs', this.id)
          .then(() => {
            this.slika = null
            this.dokument = null
            this.$Progress.finish()
            this.$buefy.snackbar.open('Подаци су обрисани успешно')

            this.$router.push({ path: this.returnTo })
          })
          .catch(error => {
            this.$Progress.finish()
            this.$buefy.snackbar.open('Дошло је до грешке!')
            console.log(error.response)
          })
      }
    },
    dodajResursSliku(file) {
      //if (files) {
      //files.forEach(file => {
      this.elementi.push({
        id: Date.now(),
        resurs_id: this.resurs ? this.resurs.id : null,
        tip: 'slika',
        tekst: file.name,
        url: this.element_url,
        file: file,
        dodat: true
      })
      //})
      //}

      // this.element_tekst = ''
      // this.element_url = ''
      // this.isModalResursLinkActive = false
    },
    dodajResursDokument(file) {
      //if (files) {
      //files.fofEach(file => {
      this.elementi.push({
        id: Date.now(),
        resurs_id: this.resurs.id,
        tip: 'dokument',
        tekst: file.name,
        url: this.element_url,
        file: file,
        dodat: true
      })
      //})
      //}

      // this.element_tekst = ''
      // this.element_url = ''
      // this.isModalResursLinkActive = false
    },
    dodajResursElement() {
      this.elementi.push({
        id: Date.now(),
        resurs_id: this.resurs.id,
        tip: 'link',
        tekst: this.element_tekst,
        url: this.element_url,
        dodat: true
      })
      this.element_tekst = ''
      this.element_url = ''
      this.isModalResursLinkActive = false
    },
    ...mapActions('resursi', ['dajResurs'])
  },
  computed: {
    slike() {
      return this.elementi.filter(e => {
        return e.tip === 'slika' && !e.obrisan
      })
    },
    dokumenti() {
      return this.elementi.filter(e => {
        return e.tip === 'dokument' && !e.obrisan
      })
    },
    linkovi() {
      return this.elementi.filter(e => {
        return e.tip === 'link' && !e.obrisan
      })
    },
    returnTo() {
      if (this.tip === 'vest') {
        return '/vesti'
      } else if (this.tip === 'javna-nabavka') {
        return '/javne-nabavke'
      } else if (this.tip === 'cenovnik') {
        return '/cenovnici'
      } else if (this.tip === 'program') {
        return '/programi'
      } else if (this.tip === 'izvestaj') {
        return '/izvestaji'
      } else if (this.tip === 'organizacija') {
        return '/organizacija'
      } else {
        return '/'
      }
    },
    titleText() {
      if (this.tip === 'vest') {
        return this.id ? 'Измена вести' : 'Нова вест'
      } else if (this.tip === 'javna-nabavka') {
        return this.id ? 'Измена јавне набавке' : 'Нови јавна набавка'
      } else if (this.tip === 'cenovnik') {
        return this.id ? 'Измена ценовника' : 'Нови ценовник'
      } else if (this.tip === 'program') {
        return this.id ? 'Измена програма' : 'Нови програм'
      } else if (this.tip === 'izvestaj') {
        return this.id ? 'Измена извештаја' : 'Нови извештај'
      } else if (this.tip === 'organizacija') {
        return this.id ? 'Измена организације' : 'Нова организација'
      } else {
        return '/'
      }
    },
    postojiSlika() {
      if (this.tip === 'vest') {
        return true
      } else if (this.tip === 'javna-nabavka') {
        return true
      } else if (this.tip === 'cenovnik') {
        return false
      } else if (this.tip === 'cenovnik') {
        return false
      } else if (this.tip === 'program') {
        return false
      } else if (this.tip === 'izvestaj') {
        return false
      } else if (this.tip === 'organizacija') {
        return false
      } else {
        return false
      }
    },
    ...mapState({
      resurs: state => state.resursi.resurs
    })
    //...mapGetters(['resursi', ['dajResursById']])
  },
  validations: {
    naslov: {
      required
    }
  }
  // pratomo kad se state.resirsi.resurs (koji je mapiran na this.resurs)
  // i kopitamo u lokalne promenljive
  // prebaceno u sreated (ovde nesto nije htelo)
  // watch: {
  //   resurs: function() {
  //     this.tekst = this.resurs.tekst
  //     this.naziv_slike = this.resurs.naziv_slike
  //     this.naziv_dokumenta = this.resurs.naziv_dokumenta
  //   }
  // }
}
</script>

<style></style>
